import { isNil } from 'lodash'
import type { Contact, Debtor, Identifier } from '@/shared/models/debtorModels'
import { EMPTY_VALUE } from '@hello-aria/ui/empty-value'

const getFlagEmoji = (countryCode: string | undefined): string => {
    if (!countryCode) return ''
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map((char) => 127397 + char.charCodeAt(0)) // Convert to regional indicator symbols
    return String.fromCodePoint(...codePoints)
}
export const getDebtorDisplayName = (
    debtorName: Debtor['name'] | undefined,
    debtorIdentifier: Identifier | undefined | null
): string => {
    if (debtorName) {
        return debtorName
    }
    return displayFormattedIdentifier(debtorIdentifier)
}

export const displayFormattedIdentifier = (identifier: Identifier | undefined | null): string => {
    if (isNil(identifier)) {
        return EMPTY_VALUE
    }
    const { value, type, country } = identifier
    const flagEmoji = getFlagEmoji(country)
    return `${value} (${type.toUpperCase()}) ${flagEmoji}`
}

export const cleanContact = (contact: Contact): Contact => {
    const { email, firstName, lastName, phoneNumber, position } = contact
    return { email, firstName, lastName, phoneNumber, position }
}
